import React from 'react';
import { btnStyle } from '../../styles/theme';

function EquipmentItem({ item, character, setCharacter, idx }) {
  function updateItem(updates) {
    const newEquipment = [...(character.equipment || [])];
    newEquipment[idx] = { ...item, ...updates };
    setCharacter({ ...character, equipment: newEquipment });
  }

  function deleteItem() {
    const newEquipment = character.equipment.filter((_, i) => i !== idx);
    setCharacter({ ...character, equipment: newEquipment });
  }

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, background: "rgba(20,16,10,0.4)", border: "1px solid rgba(201,168,76,0.15)", borderRadius: 6, padding: "8px 12px", marginBottom: 6 }}>
      <input
        value={item.name}
        onChange={(e) => updateItem({ name: e.target.value })}
        placeholder="Item name"
        style={{
          flex: 1,
          background: "rgba(0,0,0,0.3)",
          border: "1px solid rgba(201,168,76,0.2)",
          borderRadius: 4,
          padding: "6px 10px",
          color: "#e8dcc8",
          fontSize: "12px"
        }}
      />
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <label style={{ fontSize: "10px", color: "#6b6048" }}>Qty:</label>
        <input
          type="number"
          value={item.quantity}
          onChange={(e) => updateItem({ quantity: parseInt(e.target.value) || 0 })}
          min="0"
          style={{
            width: 50,
            background: "rgba(0,0,0,0.3)",
            border: "1px solid rgba(201,168,76,0.2)",
            borderRadius: 4,
            padding: "4px 6px",
            color: "#e8dcc8",
            fontSize: "12px",
            textAlign: "center"
          }}
        />
      </div>
      <button onClick={deleteItem} style={{ ...btnStyle("#c0392b", "transparent"), padding: "4px 8px", fontSize: "10px" }}>×</button>
    </div>
  );
}

export default EquipmentItem
